import { Button } from "@workspace/ui/components/button";
import { ArrowRight, MailIcon } from "lucide-react";
import { useRouter, useSearchParams } from "next/navigation";

export const MagicLinkSignInButton = () => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const params = new URLSearchParams(searchParams.toString());

  return (
    <Button
      variant="outline"
      className="flex w-full justify-between py-2 pl-3 pr-2 text-xs"
      onClick={() => {
        router.push(`/email-login?${params.toString()}`);
      }}
    >
      <span className="flex items-center gap-2">
        <MailIcon className="h-3.5 w-3.5" />
        <span>Continue with Email</span>
      </span>
      <ArrowRight size={14} className="flex-shrink-0 font-bold" />
    </Button>
  );
};
